"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransferpayload = exports.getSignTransactionPayload = exports.useCreateNativeTransfer = exports.useSignTransaction = exports.useTxQueue = exports.useTxHistory = void 0;
const addresses_1 = require("../utils/addresses");
const client_1 = require("@apollo/client");
const graphqlQueries_1 = require("./graphqlQueries");
const tx_1 = require("../types/tx");
function useTxHistory(safeAddress, chainId, pollInterval) {
    const rawAddress = safeAddress ? (0, addresses_1.toRawAddress)(safeAddress) : "";
    const { loading, error, data, refetch } = (0, client_1.useQuery)(graphqlQueries_1.GET_TX_HISTORY, {
        variables: { chainId: chainId, safeAddress: rawAddress },
        pollInterval: pollInterval ?? 0,
    });
    return {
        data: !loading && !error && data ? data.transactionHistory : [],
        error,
        loading,
        refetch,
    };
}
exports.useTxHistory = useTxHistory;
function useTxQueue(safeAddress, chainId, pollInterval) {
    const rawAddress = safeAddress ? (0, addresses_1.toRawAddress)(safeAddress) : "";
    const { loading, error, data, refetch } = (0, client_1.useQuery)(graphqlQueries_1.GET_TX_QUEUE, {
        variables: { chainId: chainId, safeAddress: rawAddress },
        pollInterval: pollInterval ?? 0,
    });
    return {
        data: !loading && !error && data ? data.transactionQueue : [],
        error,
        loading,
        refetch,
    };
}
exports.useTxQueue = useTxQueue;
function useSignTransaction() {
    const [signTransaction, { data, loading, error }] = (0, client_1.useMutation)(graphqlQueries_1.SIGN_TX);
    return {
        signTransaction,
        data: !loading && !error && data ? data.signTransaction : null,
        error,
        loading,
    };
}
exports.useSignTransaction = useSignTransaction;
function useCreateNativeTransfer() {
    const [createTransfer, { data, loading, error }] = (0, client_1.useMutation)(graphqlQueries_1.CREATE_TX);
    return {
        createTransfer,
        data: !loading && !error && data ? data.createTransfer : null,
        error,
        loading,
    };
}
exports.useCreateNativeTransfer = useCreateNativeTransfer;
const getSignTransactionPayload = async (chainId, signature, ownerAddress, queryId, safeAddress) => {
    const payload = {
        chainId: chainId,
        ownerAddress: ownerAddress,
        signature: signature,
        queryId: queryId,
        safeAddress: safeAddress,
    };
    return payload;
};
exports.getSignTransactionPayload = getSignTransactionPayload;
const getTransferpayload = async (params) => {
    let transferInfo = {};
    if (!params.signatures) {
        throw new Error("No Signatures");
    }
    if (params.tokenInfo) {
        if (params.tokenInfo.tokenSymbol === "TON") {
            transferInfo = {
                native: {
                    transferType: tx_1.TransferType.NATIVE_TRANSFER,
                    value: params.amount,
                },
            };
        }
        else {
            transferInfo = {
                ft: {
                    decimals: params.tokenInfo.decimals,
                    logoUri: params.tokenInfo.logoUri,
                    tokenAddress: params.tokenInfo.jettonMinterAddress,
                    tokenName: params.tokenInfo.tokenName,
                    tokenSymbol: params.tokenInfo.tokenSymbol,
                    transferType: tx_1.TransferType.FT_TRANSFER,
                    value: params.amount,
                },
            };
        }
    }
    const payload = {
        chainId: params.safe.chainId,
        safeAddress: (0, addresses_1.toRawAddress)(params.safe.address),
        transfer: {
            direction: tx_1.DirectionType.OUTGOING,
            recipient: params.recipient,
            sender: (0, addresses_1.toRawAddress)(params.wallet.address),
            transferInfo: transferInfo,
        },
        multiSigExecutionInfo: {
            orderCellBoc: params.orderCellBoc,
            confirmations: params.signatures,
            confirmationsRequired: params.safe.threshold,
            confirmationsSubmitted: 1,
            executor: "",
            expiredAt: parseInt(params.expiredTime, 10),
            queryId: params.queryId,
        },
    };
    return payload;
};
exports.getTransferpayload = getTransferpayload;
